<template>
  <section
    class="bg-white md:p-8 p-4 flex flex-col h-full rounded-sm border border-royal-blue-20"
    data-testid="card">
    <h2 class="font-bitter text-2xl font-bold mb-4">
      <slot name="cardTitle">
      </slot>
    </h2>
    <div class="grow mb-4">
      <p>
        <slot name="cardDescription">
        </slot>
      </p>
    </div>
    <div class="mt-auto">
      <slot name="cardButton">
      </slot>
    </div>
  </section>
</template>
